/* =========================================================================
   Mindful Yard — collection category chips
   Chips carrying data-my-catchip filter the product grid in place, using the
   category derived on each card (data-my-cat). Chips that link to a real
   collection or tag are left alone — the browser handles those.
   ========================================================================= */
(function () {
  'use strict';

  function init() {
    var chips = [].slice.call(document.querySelectorAll('[data-my-catchip]'));
    if (!chips.length) return;

    var grid = document.querySelector('[data-filter-grid], .my-grid--collection, .my-collgrid .my-grid');
    if (!grid) return;
    var cards = [].slice.call(grid.querySelectorAll('.my-card'));
    if (!cards.length) return;

    var countEl = document.querySelector('.my-collhead__count');
    var allChip = document.querySelector('[data-my-catchip="all"]');

    function apply(cat, push) {
      var shown = 0;
      cards.forEach(function (card) {
        var match = (cat === 'all') || (card.getAttribute('data-my-cat') === cat);
        card.style.display = match ? '' : 'none';
        if (match) shown++;
      });

      chips.forEach(function (c) {
        c.classList.toggle('my-chip--active', c.getAttribute('data-my-catchip') === cat);
      });

      if (countEl) {
        countEl.textContent = shown + (shown === 1 ? ' product' : ' products');
      }

      // Empty state
      var empty = grid.querySelector('[data-my-catempty]');
      if (shown === 0) {
        if (!empty) {
          empty = document.createElement('div');
          empty.className = 'my-empty';
          empty.setAttribute('data-my-catempty', '');

          var t = document.createElement('div');
          t.className = 'my-empty__title';
          t.textContent = 'Nothing here yet';

          var b = document.createElement('p');
          b.className = 'my-empty__body';
          b.textContent = 'We’re still stocking this category.';

          empty.appendChild(t);
          empty.appendChild(b);
          grid.appendChild(empty);
        }
        empty.style.display = '';
      } else if (empty) {
        empty.style.display = 'none';
      }

      // Keep the URL shareable without a reload.
      if (push && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (cat === 'all') url.searchParams.delete('c');
        else url.searchParams.set('c', cat);
        window.history.replaceState({}, '', url.toString());
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        apply(chip.getAttribute('data-my-catchip'), true);
      });
    });

    // Restore from ?c= on load (so a filtered view can be linked/shared).
    var initial = new URL(window.location.href).searchParams.get('c');
    if (initial) {
      apply(initial, false);
    } else if (allChip) {
      allChip.classList.add('my-chip--active');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
